import type { MappingData } from 'api/fetchCommon';

export type MappingKind = keyof MappingData;

export const getMappingLabel = (
    mapping: MappingData | null,
    kind: MappingKind,
    id: string | null | undefined,
): string => {
    if (id == null) return '';
    return mapping?.[kind]?.[id] ?? id;
};

export const buildLabeledOptions = (
    mapping: MappingData | null,
    kind: MappingKind,
    ids: readonly string[],
): { value: string; label: string }[] =>
    ids.map(id => ({ value: id, label: getMappingLabel(mapping, kind, id) }));
